module.exports = __webpack_public_path__ + "static/media/Papua New Guinea.9076c690.png";